const ADMIN = 'Admin'
const USER = 'User'

export const allRoles = [ ADMIN, USER ]

export { ADMIN, USER }

export default { ADMIN, USER, allRoles }